import fetchLikertTest from './fetchLikertTest';
import fetchLikertTestResult from './fetchLikertTestResult';
import submitLikertTest from './submitLikertTest';

export default [
  fetchLikertTest,
  fetchLikertTestResult,
  submitLikertTest,
];
